import { useAtom } from 'jotai'
import {
  progressOffsetAtom,
  timelineMinimumsAtom
} from '../atoms/timeline.atom'
import {
  BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX,
  TIMELINE_PRODUCT_ROW_HEIGHT_PX,
  TIMELINE_DATA_SERIES_Z_INDEX
} from '../timeline.constants'
import { useTimelineDimensions } from '../hooks/useTimelineDimensions'
import { Fragment } from 'react'
import {
  GreyGrey10,
  GreyGrey20,
  GreyGrey50,
  GreyGrey60,
  GreyGrey80,
  Primary12SemiBold,
  Primary12Regular,
  Box
} from '@sequencehq/core-components'
import { BillingPeriodPill, getProgressFillWidth } from './BillingPeriodPill'
import { hoveredMinimumAtom } from '../atoms/timelineUi.atom'

const minimumsTheme = {
  border: GreyGrey50,
  progressFill: GreyGrey20,
  upcomingFill: GreyGrey10
}

export const ScheduleTimelineMinimums = () => {
  const [minimums] = useAtom(timelineMinimumsAtom)
  const [progressOffset] = useAtom(progressOffsetAtom)
  const { timelineWidth } = useTimelineDimensions()
  const [, setHoveredMinimum] = useAtom(hoveredMinimumAtom)

  if (!minimums.length) {
    return null
  }

  return (
    <Box
      width={`${timelineWidth}px`}
      height={`${TIMELINE_PRODUCT_ROW_HEIGHT_PX}px`}
      zIndex={TIMELINE_DATA_SERIES_Z_INDEX}
      position="relative"
    >
      {minimums.map(minimum => {
        return (
          <Fragment key={`product-minimum-${minimum.id}`}>
            <Box
              position="absolute"
              top="8px"
              left={`${minimum.startDate.offset + BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX}px`}
              {...Primary12SemiBold}
              color={GreyGrey80}
            ></Box>
            <Box
              position="absolute"
              top="48px"
              left={`${minimum.startDate.offset + BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX}px`}
              {...Primary12Regular}
              color={GreyGrey60}
            ></Box>
          </Fragment>
        )
      })}
      {minimums.map(minimum => {
        const pillStartOffset =
          minimum.startDate.offset + BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX
        const pillEndOffset = minimum.endDate.offset

        return (
          <Box
            position="absolute"
            top="28px"
            left={`${pillStartOffset}px`}
            key={minimum.id}
          >
            <BillingPeriodPill
              isMinimum
              theme={minimumsTheme}
              progressFillWidth={getProgressFillWidth({
                startOfPeriodOffset: pillStartOffset,
                endOfPeriodOffset: pillEndOffset,
                progressOffset
              })}
              width={(pillEndOffset ?? 0) - pillStartOffset}
              openEndedFillWidth={
                minimum.openEnded ? pillEndOffset - pillStartOffset : 0
              }
              onMouseEnter={() => {
                setHoveredMinimum(minimum.id)
              }}
              onMouseLeave={() => {
                setHoveredMinimum(null)
              }}
            />
          </Box>
        )
      })}
    </Box>
  )
}
